import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"

export const PageObjClass = Scrivito.provideObjClass("Page", {
  attributes: {
    ...defaultPageAttributes,
    data: "datalocator"
  },
  extractTextAttributes: ["body"]
})
export type PageObj = InstanceType<typeof PageObjClass>
